<script setup>
import { computed } from 'vue';

/* Props */
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  tooltipText: {
    type: String,
    default: '',
  },
});

const hasTooltipText = computed(() => props.tooltipText && props.tooltipText !== 'undefined');
</script>

<template>
  <div class="app__tooltip">
    <!-- eslint-disable vue/no-v-text-v-html-on-component -->
    <g-tooltip>
      <span
        slot="tooltip-title"
        v-html="props.title"
      />
      <span
        v-if="hasTooltipText"
        slot="tooltip-text"
        v-html="props.tooltipText"
      />
    </g-tooltip>
    <!-- eslint-enable vue/no-v-text-v-html-on-component -->
  </div>
</template>

<style lang="scss" scoped>
.app__tooltip {
  font-size: 0.75em;

  @include productBreakpoint('desktop-s') {
    max-width: 400px;
  }

  // Adds old icon back to global tooltip while using latest version of global web components for backwards compatibility
  :deep(.g__tooltip__icon) {
    background: url('data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iZ19fdG9vbHRpcF9faWNvbl9fc3ZnIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiByb2xlPSJpbWciIGFyaWEtbGFiZWxsZWRieT0iZjhmYW83ZWYxdG8iPjx0aXRsZSBpZD0iZjhmYW83ZWYxdG8iPlF1ZXN0aW9uIE1hcmsgSWNvbjwvdGl0bGU+PGNpcmNsZSBjbGFzcz0iZ19fdG9vbHRpcF9faWNvbl9fc3ZnX19maWxsIiByb2xlPSJwcmVzZW50YXRpb24iIGN4PSI0OS44IiBjeT0iNTAuMiIgcj0iNDguOCIgZmlsbD0icmdiKDExNC43NSwgMTE0Ljc1LCAxMTQuNzUpIj48L2NpcmNsZT48cGF0aCBmaWxsPSIjZmZmIiBjbGFzcz0iZ19fdG9vbHRpcF9faWNvbl9fc3ZnX19jb250ZW50IiByb2xlPSJwcmVzZW50YXRpb24iIGQ9Ik00NS4zIDYwLjJ2LTIuNWMwLTIuMi41LTQuMSAxLjQtNS43LjktMS42IDIuNi0zLjMgNS4xLTUuMiAyLjQtMS43IDQtMy4xIDQuNy00LjIuOC0xLjEgMS4xLTIuMwogICAgICAgICAgICAgICAgICAxLjEtMy42IDAtMS41LS41LTIuNi0xLjYtMy40LTEuMS0uOC0yLjYtMS4yLTQuNi0xLjItMy40IDAtNy4zIDEuMS0xMS43IDMuM0wzNiAzMC40YzUuMS0yLjggMTAuNS00LjMKICAgICAgICAgICAgICAgICAgMTYuMi00LjMgNC43IDAgOC40IDEuMSAxMS4yIDMuNHM0LjIgNS4zIDQuMiA5YzAgMi41LS42IDQuNy0xLjcgNi41LTEuMSAxLjgtMy4zIDMuOS02LjUgNi4yLTIuMgogICAgICAgICAgICAgICAgICAxLjYtMy42IDIuOC00LjIgMy43LS42LjgtLjkgMS45LS45IDMuM3YyLjFoLTl6bS0xLjEgMTEuN2MwLTEuOS41LTMuNCAxLjUtNC4zIDEtMSAyLjUtMS41IDQuNS0xLjUKICAgICAgICAgICAgICAgICAgMS45IDAgMy40LjUgNC40IDEuNSAxIDEgMS42IDIuNCAxLjYgNC4zIDAgMS44LS41IDMuMi0xLjYgNC4zLTEgMS0yLjUgMS42LTQuNCAxLjYtMS45CiAgICAgICAgICAgICAgICAgIDAtMy40LS41LTQuNC0xLjUtMS4xLTEuMS0xLjYtMi41LTEuNi00LjR6Ij48L3BhdGg+PC9zdmc+') center center no-repeat;
    width: 0.82rem;
    height: 0.82rem;
  }

  :deep(.g__tooltip__icon svg) {
    display: none;
  }
}
</style>
